import { PressReleaseFlat } from "@clients/afaseApiClient";
import { PressreleaseUrlStructureFactory } from "@factory/PressreleaseUrlStructureFactory";

import { UrlStructureItem } from "types/UrlStructureItem";

export const getMappedPressreleaseUrlStructure = (
  items: Array<PressReleaseFlat>,
): UrlStructureItem[] => {
  return items?.length ? PressreleaseUrlStructureFactory(items) : [];
};
